import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Action,
  MutationReorderBadgesArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'

export const useReorderBadges = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationReorderBadgesArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()

  return useMutation<Action, ClientError, MutationReorderBadgesArgs>(
    variables =>
      client.mutation({
        name: 'reorderBadges',
        args: { variables, fields: 'basic' },
      }),
    useMutationOptions,
  )
}
